import React, { useEffect, useImperativeHandle, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { default as ReactSelect, components } from "react-select";
import Maybe from "components/__new/common/Maybe";
import * as employeeAction from "store/entities/employees/action";


export const SearchableEmployees = React.forwardRef((props, ref) => {
    const dispatch = useDispatch();
    const { employeesLoading, employees } = useSelector((s) => s.entities.employees);


    const [options, setOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState({});


    const getOptions = () => {
        if (employees?.employees?.docs !== undefined && employees?.employees?.docs?.length > 0){
          const data = employees.employees.docs.map((employee) => {
            return {
              label: employee.fullName ? employee.fullName : employee.firstName + " " + employee.lastName,
              value: employee._id,
              phoneNumber: employee.phoneNumber,
            }
          })
          setOptions(data);
        }
        else{
            setOptions([]);
        }
    }


    const updateSelection = (e) => {
        // setSelectedOption(e);
        // props.onValueChange(e);

        setSelectedOption(e);
        const employee = employees?.employees?.docs?.filter((employee) => employee._id === e.value);
        props.onValueChange(employee[0] || {});
    }


    const clearSearchableEmployees = () => {
        setSelectedOption({});
    }


    useEffect(() => {
        const params = {
            "page": 1,
            "limit": 5000,
        }
        dispatch(employeeAction.getAllEmployees(params));
        // eslint-disable-next-line
    }, []);


    useEffect(() => {
        if (employees?.status === "success"){
            getOptions();
        }
        // eslint-disable-next-line
    }, [employees]);


    useImperativeHandle(ref, () => ({
        clearSearchableEmployees
    }));


    return (
        <div className="form-group">
            <label>
                {props.label || "Search employees"}
                <Maybe condition={props.required === true}>
                    <span className="form-input-required">*</span>
                </Maybe>
            </label>

            <Maybe condition={employeesLoading === true}>
                <input type="text" value="Loading employees..." readOnly={true} className="form-input" />
            </Maybe>

            <Maybe condition={employeesLoading === false}>
                <ReactSelect
                    options={options}
                    placeholder="Select employee"
                    noOptionsMessage={() => "No employees yet"}
                    styles={ReactSelectStyles}
                    isMulti={false}
                    closeMenuOnSelect={true}
                    hideSelectedOptions={false}
                    components={{Option}}
                    onChange={(e) => updateSelection(e)}
                    value={selectedOption}
                />
            </Maybe>
        </div>
    )
})



const Option = (props) => {
    return (
        <div className="p-0">
            <components.Option {...props}>
                <div className="-mx-2 -my-1.5 p-4 text-sm flex justify-between border rounded-sm">
                    <div className="w-10 flex-shrink-0">
                      <input
                        type="radio"
                        checked={props.isSelected}
                        onChange={() => null}
                        className="w-5 h-5 form-radio rounded-full capitalize"
                      />
                    </div>
                    <div className="flex-grow text-left font-semibold capitalize">
                        {props.label}
                        <br />
                        <span className="text-fade">{props.data.phoneNumber}</span>
                    </div>
                </div>
            </components.Option>
        </div>
    );
};


  
const ReactSelectStyles = {
    option: (provided, state) => ({
        ...provided,
        color: "#333",
        background: "#fff",
        cursor: "pointer",
        "&:hover": {
            background: "#eee",
        }
    }),
};

  

export default SearchableEmployees;